const not = (...predicates) => {
  return traffic => {
    return predicates.every(predicate => {
      return !predicate(traffic)
    })
  }
}

export default not



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/not.js